<template>
  <v-row
    no-gutters
    class="fill-height">
    <!-- <v-breadcrumbs
      class="ml-n5"
      :items="breadcrumbs"
      divider="/"
    ></v-breadcrumbs> -->
    <v-col class="px-6 pt-2 pb-12 fill-height">
      <h1 class="display-1">
        {{ $t("companies") }}
        <span>
          {{ companiesLength }} {{$t("total")}}</span>
      </h1>
      <h2 class="subtitle-2">{{ $t("clientsSubtitle") }}</h2>
      <div class="pt-5 pb-5 d-flex align-end justify-space-between">
        <div
          class="pb-0"
          cols="4">
        </div>
      </div>
      <v-sheet class="table" height="800">
      <v-data-table
        :headers="tableheaders"
        :items="companies"
        :search="model.search"
        :loading="isLoadingTable"
        :loading-text="$t('loadingData')"
        v-model="model.selected"
        fixed-header
        max-height="550px"
        item-key="tag"
        class="clients-table max-height elevation-1"
      >
        <template v-slot:no-data>
          {{ $t("companiesEmpty") }}
        </template>
      </v-data-table>
    </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { commonModule, clientsModule, installationsModule, distributorModule } from '@/store/modules/store-accessor'
import Dropdown from '../components/dropdown/Dropdown.vue'
import DropdownItem from '../components/dropdown/DropdownItem.vue'


@Component({
  components: { Dropdown, DropdownItem }
})
export default class Companies extends Vue {
  tableheaders: any [] = [
      { text: this.$t("name"), sortable: true, class: 'row-style', value: 'entity_name' },
      { text: this.$t("phone"), align: 'left', sortable: true, class: 'row-style', value: 'contact' },
      { text: this.$t("email"), sortable: true, class: 'row-style', value: 'email' },
      { text: this.$t("devices_assigned"), sortable: true, class: 'row-style', value: 'devices_assigned' },      
      { text: this.$t("devices_installed"), sortable: true, class: 'row-style', value: 'devices_installed' },      
      { text: '', align: 'right', sortable: false, class: 'row-style', value: 'id' } 
    ]

  model: any = {
    search: '',
    selected: [] as string[]
  }

  async mounted () {
    /*
     TODO: Handle clients properly when UX is clear.
     */
    distributorModule.getDistributorCompanies();
    commonModule.initSnackbar({});
  }

  get companiesLength() {
    return this.companies.length
  }

  get searchLabel() {
    return this.$t("clientsSearch")
  }

  get companies(){
    return distributorModule.distributorCompanies
  }

  get isLoadingTable() {
    return distributorModule.isLoadingTable;
  }

}
</script>

<style scoped lang="scss">

.client-table:not(thead) {
  cursor: pointer;
  min-width: 600px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}


.max-height {
  max-height: 65vh;
  overflow: auto;
}

.placeholder {
  background-color: grey
}

h1 {
  margin-top: 40px;
  font-size: 35px;
  font-weight: 500;
  line-height: 65px;
}

span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 400;
  color: $pale-purple;
}
</style>
